// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfonts/iconfont.css
// module id = zLbt
// module chunks = 24